import { MapCircle } from '../models/map.circle';
import { MapLatLng } from '../models/map.latlng';

declare var google: any;

export class GCircle extends MapCircle {
    public circle: any;
    private markerText: any;

    constructor(id: number, map: any, content: string, strokeColor: string, strokeOpacity: number,
        strokeWeight: number, fillColor: string, fillOpacity: number, center: MapLatLng,
        radius: number, editable: boolean, draggable: boolean) {
        super(id, map, content, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity,
            center, radius, editable, draggable);
        this.circle = new google.maps.Circle({
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
            fillColor: fillColor,
            fillOpacity: fillOpacity,
            map: map,
            center: new google.maps.LatLng(center.lat, center.lng),
            radius: this.radius,
            visible: true,
            editable: editable,
            draggable: draggable
        });
        // Pongo el texto en el centro
        if (this.content && this.content.length > 0) {
            this.markerText = new google.maps.Marker({
                position: new google.maps.LatLng(center.lat, center.lng),
                label: content,
                map: this.map,
                icon: 'assets/images/void.png'
            });
        }
    }

    // Borra un círculo
    remove() {
        this.circle.setMap(null);
        if (this.markerText) {
            this.markerText.setMap(null);
        }
    }

    // Asigna el contenido que se ve al pinchar sobre un círculo
    setContent(content: string) {
        this.content = content;
        if (this.markerText) {
            this.markerText.setMap(null);
            this.markerText = null;
        }
        // Pongo el texto en el centro
        if (this.content && this.content.length > 0) {
            this.markerText = new google.maps.Marker({
                position: new google.maps.LatLng(this.center.lat, this.center.lng),
                label: content,
                map: this.map,
                icon: 'assets/images/void.png'
            });
        }
    }

    // Pone el centro
    setCenter(position: MapLatLng) {
        this.center = position;
        this.circle.setCenter(new google.maps.LatLng(position.lat, position.lng));
        if (this.markerText) {
            this.markerText.setPosition(new google.maps.LatLng(position.lat, position.lng));
        }
    }

    // Pone el radio
    setRadius(radius: number) {
        this.radius = radius;
        this.circle.setRadius(radius);
    }

}
